import { AnnouncementScope } from '@tabeeb/contracts/microservices/swagger-article-service'

export const AnnouncementScopeDisplayName: Record<AnnouncementScope, string> = {
  [AnnouncementScope.System]: 'System',
  [AnnouncementScope.Corporation]: 'Corporation',
  [AnnouncementScope.Tenant]: 'Tenant',
}

export { AnnouncementScope }
